import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function PrivateRoute({ children }) {
  const { user, authChecked, handleTokenVerification } = useAuth();

  useEffect(() => {
    handleTokenVerification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!authChecked) return null;

  return user ? <>{children}</> : <Navigate to="/login" />;
}
